export const SWITCH_BREAKPOINT = 'SWITCH_BREAKPOINT';
import { Action } from 'redux';

export type SwitchBreakpointAction = Action & {
  newBreakpoint: number;
};

const breakpointCookieName = 'pop.breakpoint';

export function switchBreakpoint(newBreakpoint: number) {
  if(newBreakpoint > 1) {
    newBreakpoint = 1;
  }
  document.cookie = breakpointCookieName + '=' + newBreakpoint + ';path=/;max-age=' + 60 * 60 * 24 * 365;

  return {
    type: SWITCH_BREAKPOINT,
    newBreakpoint,
  } as SwitchBreakpointAction;
}
